module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-scripts/~/babel-runtime/core-js/symbol.js
// module id = 910
// module chunks = 0